import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { contractModificationsWizardSteps } from 'src/app/models/wizard-enum';

@Component({
  selector: 'contract-modification-payment-source',
  templateUrl: './payment-source.component.html',
  styleUrls: ['./payment-source.component.scss'],
  standalone: false,
})
export class PaymentSourceComponent {
  wizardStepsEnum = contractModificationsWizardSteps;

  @Input() contractModificationRequest: app.models.ContractModificationRequest;
  @Input() paymentSourcesDatasource: app.models.DictionaryDataModel[];
  @Input() secondQuestionFormGroup: FormGroup;

  @Input() nextStepHandler: any;
  @Input() deleteFileHandler: any;
  @Input() uploadFilesHandler: any;
}
